export default {
  Neutral: 'rgb(255, 234, 182)',
  Positive: 'rgb(209, 247, 196)',
  Negative: 'rgb(255, 158, 183)',
  Unsure: 'rgb(204, 204, 204)',
}
